export default {"src":"/_next/static/media/icon_chat_request_sent.4acebe88.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};